// EXEMPT
import type { GamesWithProp } from "@/app/games.mjs";

type ShortName = GamesWithProp<"shortName">["shortName"];

export default function gameShortNameReassign(shortName: ShortName): ShortName {
  // @ts-ignore
  if (shortName === "cs2") return "csgo";
  return shortName;
}
